var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 0)?_c('div',{staticClass:"tags"},[_c('ul',_vm._l((_vm.items),function(tag){return _c('li',{key:tag,staticClass:"tag"},[_vm._v(_vm._s(tag))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }